import Vue from 'vue'
import Router from 'vue-router'
import i18n from '../locale/i18n'

const XingShanHome = r => require.ensure([], () => r(require('../page/xingshan/Home')), 'Home')
const XingShanHomeConfirm = r => require.ensure([], () => r(require('../page/xingshan/HomeConfirm')), 'HomeConfirm')
const XingShanHomeSign = r => require.ensure([], () => r(require('../page/xingshan/HomeSign')), 'HomeSign')
const XingShanHomeWalk = r => require.ensure([], () => r(require('../page/xingshan/HomeWalk')), 'HomeWalk')
const XingShanWalk = r => require.ensure([], () => r(require('../page/xingshan/Walk')), 'Walk')
const XingShanInter = r => require.ensure([], () => r(require('../page/xingshan/Inter')), 'Inter')
const XingShanLogin = r => require.ensure([], () => r(require('../page/xingshan/Login')), 'Login')
const XingShanLoginConfirm = r => require.ensure([], () => r(require('../page/xingshan/LoginConfirm')), 'LoginConfirm')
const XingShanSign = r => require.ensure([], () => r(require('../page/xingshan/Sign')), 'Sign')
const XingShanSignRules = r => require.ensure([], () => r(require('../page/xingshan/SignRules')), 'SignRules')
const XingShanSignPrivacy = r => require.ensure([], () => r(require('../page/xingshan/SignPrivacy')), 'SignPrivacy')
const XingShanSignPersonal = r => require.ensure([], () => r(require('../page/xingshan/SignPersonal')), 'SignPersonal')
const XingShanSignConfirm = r => require.ensure([], () => r(require('../page/xingshan/SignConfirm')), 'SignConfirm')
const XingShanSignFail = r => require.ensure([], () => r(require('../page/xingshan/SignFail')), 'SignFail')
const XingShanResult = r => require.ensure([], () => r(require('../page/xingshan/Result')), 'Result')
const XingShanError = r => require.ensure([], () => r(require('../page/xingshan/Error')), 'Error')
const XingShanConfirmAdvance = r => require.ensure([], () => r(require('../page/xingshan/HomeConfirmAdvance')), 'HomeConfirmAdvance')
const XingShanTransferConfirm = r => require.ensure([], () => r(require('../page/xingshan/HomeTransferConfirm')), 'HomeTransferConfirm')
const XingShanBindPhone = r => require.ensure([], () => r(require('../page/xingshan/BindPhone')), 'bindPhone')
const XingShanWalkNotEnough = r => require.ensure([], () => r(require('../page/xingshan/WalkNotEnough')), 'WalkNotEnough')
const XingShanWalkReward = r => require.ensure([], () => r(require('../page/xingshan/WalkReward')), 'WalkReward')
const XingShanPhotoRules = r => require.ensure([], () => r(require('../page/xingshan/PhotoRules')), 'PhotoRules')
const XingShanPhotoUploadHome = r => require.ensure([], () => r(require('../page/xingshan/PhotoUploadHome')), 'PhotoUploadHome')
const XingShanPhotoUpload = r => require.ensure([], () => r(require('../page/xingshan/PhotoUpload')), 'PhotoUpload')
const XingShanPhotoUploadResult = r => require.ensure([], () => r(require('../page/xingshan/PhotoUploadResult')), 'PhotoUploadResult')
const XingShanCoupon = r => require.ensure([], () => r(require('../page/xingshan/Coupon')), 'Coupon')
const XingShanCouponList = r => require.ensure([], () => r(require('../page/xingshan/CouponList')), 'CouponList')
const XingShanHomeConfirmed = r => require.ensure([], () => r(require('../page/xingshan/HomeConfirmed')), 'HomeConfirmed')
const XingShanPhotoDetail = r => require.ensure([], () => r(require('../page/xingshan/photoPedding/photoDetail')), 'photoDetail')
const XingShanPhoto = r => require.ensure([], () => r(require('../page/xingshan/photoPedding/photo')), 'photo')
const XingShanNullPhoto = r => require.ensure([], () => r(require('../page/xingshan/photoPedding/nullPhoto')), 'nullPhoto')
const XingShanPhotoVote = r => require.ensure([], () => r(require('../page/xingshan/photoVote/index')), 'index')
const XingShanPhotoStatus = r => require.ensure([], () => r(require('../page/xingshan/photoVote/photoStatus')), 'photoStatus')
const XingShanPhotoVoteList = r => require.ensure([], () => r(require('../page/xingshan/photoVote/photoVoteList')), 'photoVoteList')
const XingShanPhotoVoteStatus = r => require.ensure([], () => r(require('../page/xingshan/photoVote/photoVoteStatus')), 'photoVoteStatus')
const XingShanSavePhoto = r => require.ensure([], () => r(require('../page/xingshan/photoResult/photoResult')), 'photoResult')
const XingShanPhotoResult = r => require.ensure([], () => r(require('../page/xingshan/photoResult/index')), 'index')
const XingShanSaveInBroswer = r => require.ensure([], () => r(require('../page/xingshan/photoResult/save')), 'save')
const XingShanEndStatus = r => require.ensure([], () => r(require('../page/xingshan/photoResult/endStatus')), 'endStatus')
const XingShanEndVote = r => require.ensure([], () => r(require('../page/xingshan/photoResult/endVoted')), 'endVoted')
import newYear from './newYear/index'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/xingshan/home'
    },
    ...newYear,
    {
      path: '/xingshan/inter',
      component: XingShanInter,
      meta: { title: i18n.t('xingshan.inter.title') }
    },
    {
      path: '/xingshan/walk',
      component: XingShanWalk,
      meta: { title: i18n.t('xingshan.walk.title') }
    },
    {
      path: '/xingshan/home',
      redirect: '/xingshan/homeConfirmed'
    },
    {
      path: '/xingshan/homeConfirm',
      redirect: '/xingshan/homeConfirmed'
    },
    {
      path: '/xingshan/homeSign',
      component: XingShanHomeSign,
      meta: { title: i18n.t('xingshan.home.title') }
    },
    {
      path: '/xingshan/homeWalk',
      component: XingShanHomeWalk,
      meta: { title: i18n.t('xingshan.home.title') }
    },
    {
      path: '/xingshan/login',
      component: XingShanLogin,
      meta: { title: i18n.t('xingshan.login.title') }
    },
    {
      path: '/xingshan/loginConfirm',
      component: XingShanLoginConfirm,
      meta: { title: i18n.t('xingshan.loginConfirm.title') }
    },
    {
      path: '/xingshan/sign',
      component: XingShanSign,
      meta: { title: i18n.t('xingshan.sign.title') }
    },
    {
      path: '/xingshan/sign/rules',
      component: XingShanSignRules,
      meta: { title: i18n.t('xingshan.sign.rules.title') }
    },
    {
      path: '/xingshan/sign/personal',
      component: XingShanSignPersonal,
      meta: { title: i18n.t('xingshan.sign.personal.title') }
    },
    {
      path: '/xingshan/sign/privacy',
      component: XingShanSignPrivacy,
      meta: { title: i18n.t('xingshan.sign.privacy.title') }
    },
    {
      path: '/xingshan/sign/confirm',
      component: XingShanSignConfirm,
      meta: { title: i18n.t('xingshan.signConfirm.title') }
    },
    {
      path: '/xingshan/sign/fail',
      component: XingShanSignFail,
      meta: { title: i18n.t('xingshan.result.signFail.title') }
    },
    {
      path: '/xingshan/result/:result',
      component: XingShanResult,
      meta: { title: i18n.t('xingshan.result.title') }
    },
    {
      path: '/xingshan/error',
      component: XingShanError,
      meta: { title: i18n.t('xingshan.error.title') }
    },
    {
      path: '/xingshan/confirmAdvance',
      component: XingShanConfirmAdvance,
      meta: { title: i18n.t('xingshan.loginConfirm.title') }
    },
    {
      path: '/xingshan/homeTransferConfirm',
      component: XingShanTransferConfirm,
      meta: { title: i18n.t('xingshan.home.title') }
    },
    {
      path: '/xingshan/bindPhone',
      component: XingShanBindPhone,
      meta: { title: i18n.t('xingshan.bindPhone.title') }
    },
    {
      path: '/xingshan/walkNotEnough',
      component: XingShanWalkNotEnough,
      meta: { title: i18n.t('xingshan.walkNotEnough.title') }
    },
    {
      path: '/xingshan/walkReward',
      component: XingShanWalkReward,
      meta: { title: i18n.t('xingshan.walkReward.title') }
    },
    {
      path: '/xingshan/photoRules',
      component: XingShanPhotoRules,
      meta: { title: i18n.t('xingshan.photoRules.title') }
    },
    {
      path: '/xingshan/photoUploadHome',
      component: XingShanPhotoUploadHome,
      meta: { title: i18n.t('xingshan.photoUploadHome.title') }
    },
    {
      path: '/xingshan/photoUpload',
      component: XingShanPhotoUpload,
      meta: { title: i18n.t('xingshan.photoUpload.title') }
    },
    {
      path: '/xingshan/photoUploadResult',
      component: XingShanPhotoUploadResult,
      meta: { title: i18n.t('xingshan.photoUploadResult.title') }
    },
    {
      path: '/xingshan/coupon',
      component: XingShanCoupon,
      meta: { title: i18n.t('xingshan.coupon.title') }
    },
    {
      path: '/xingshan/couponList',
      component: XingShanCouponList,
      meta: { title: i18n.t('xingshan.couponList.title') }
    },
    {
      path: '/xingshan/homeConfirmed',
      component: XingShanHomeConfirmed,
      meta: { title: i18n.t('xingshan.home.title') }
    },
    {
      path: '/xingshan/photoDetail',
      component: XingShanPhotoDetail,
      meta: { title: i18n.t('xingshan.photoPedding.photoDetail.title') }
    },
    {
      path: '/xingshan/photo',
      component: XingShanPhoto,
      meta: { title: i18n.t('xingshan.photoPedding.photo.title') }
    },
    {
      path: '/xingshan/nullPhoto',
      component: XingShanNullPhoto,
      meta: { title: i18n.t('xingshan.photoPedding.nullPhoto.title') }
    },
    {
      path: '/xingshan/photoVote',
      component: XingShanPhotoVote,
      meta: { title: i18n.t('xingshan.photoVote.title1') }
    },
    {
      path: '/xingshan/photoStatus',
      component: XingShanPhotoStatus,
      meta: { title: i18n.t('xingshan.photoVote.title2') }
    },
    {
      path: '/xingshan/photoVoteList',
      component: XingShanPhotoVoteList,
      meta: { title: i18n.t('xingshan.photoVote.title2') }
    },
    {
      path: '/xingshan/photoVoteStatus',
      component: XingShanPhotoVoteStatus,
      meta: { title: i18n.t('xingshan.photoVote.title3') }
    },
    {
      path: '/xingshan/savePhoto',
      component: XingShanSavePhoto,
      meta: { title: i18n.t('xingshan.photoResult.title2') }
    },
    {
      path: '/xingshan/photoResult',
      component: XingShanPhotoResult,
      meta: { title: i18n.t('xingshan.photoResult.title1') }
    },
    {
      path: '/xingshan/saveInBroswer',
      component: XingShanSaveInBroswer,
      meta: { title: i18n.t('xingshan.photoResult.title3') }
    },
    {
      path: '/xingshan/endVote',
      component: XingShanEndVote,
      meta: { title: i18n.t('xingshan.photoVote.title1') }
    },
    {
      path: '/xingshan/voteStatus',
      component: XingShanEndStatus,
      meta: { title: i18n.t('xingshan.photoVote.title2') }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }

  }
})
router.beforeEach((to, from, next) => {
  // 根据路由 meta 信息更改页面 title
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js